// AuditLog.js
import { useState, useEffect } from 'react';
import { ScrollText, Search, RefreshCw } from 'lucide-react';
import api from '../services/api';

export function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/audit', { params: { limit: 100 } })
      .then(r => setLogs(r.data || []))
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const filtered = logs.filter(l =>
    !search || l.action?.includes(search) || l.actor_email?.includes(search) || l.object_type?.includes(search)
  );

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Audit Trail</h1><p className="page-subtitle">Immutable log of all privileged actions</p></div>
        <div style={{ display: 'flex', gap: 10 }}>
          <div className="search-bar">
            <Search size={14} />
            <input placeholder="Filter by action, user, object..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <button className="btn btn-ghost" onClick={load}><RefreshCw size={14} /></button>
        </div>
      </div>
      <div className="card">
        {loading ? <div className="loading-state"><div className="spinner" /></div> : filtered.length === 0 ? (
          <div className="empty-state"><ScrollText size={48} /><h3>No audit logs</h3><p>Actions will appear here as they occur</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Time</th><th>Actor</th><th>Action</th><th>Object</th><th>Result</th><th>Details</th></tr></thead>
              <tbody>
                {filtered.map(l => (
                  <tr key={l.id}>
                    <td className="mono" style={{ fontSize: 12, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
                      {new Date(l.timestamp).toLocaleString()}
                    </td>
                    <td style={{ fontSize: 13 }}>{l.actor_email || <span style={{ color: 'var(--text-muted)' }}>system</span>}</td>
                    <td><code style={{ fontSize: 12, color: 'var(--accent-bright)', background: 'var(--accent-glow)', padding: '2px 6px', borderRadius: 4 }}>{l.action}</code></td>
                    <td style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{l.object_type}{l.object_id ? <span style={{ color: 'var(--text-muted)' }}> #{l.object_id.slice(0,8)}</span> : ''}</td>
                    <td><span className={`badge badge-${l.result === 'success' ? 'green' : 'red'}`}>{l.result}</span></td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{l.detail || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuditLog;
